import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { useRecordContext } from 'react-admin';
import DateTimeField, { DateTimeFieldProps } from 'components/DateTimeField';

interface JobProfileAvailabilityFieldProps extends Omit<DateTimeFieldProps, 'label'> {
  agencySource?: string;
  label?: string | React.ReactElement;
  sortable?: boolean;
}

export const AgencyFavoritesAvailabilityLabel = () => (
  <span>
    Available for favorites
    <Tooltip
      arrow
      title="For agency profiles, this is the earliest available-for-viewing time among that agency's offer group pairs (the minimum OGP time). It is blank when the profile has no agency favorite."
    >
      <IconButton size="small" aria-label="About available for favorites">
        <InfoOutlined fontSize="small" />
      </IconButton>
    </Tooltip>
  </span>
);

const JobProfileAvailabilityField = ({
  agencySource,
  label: _label,
  ...props
}: JobProfileAvailabilityFieldProps) => {
  const record = useRecordContext();
  const isAgency = record?.professional_type === 'agency';
  const source = isAgency && agencySource ? agencySource : props.source;
  const timezone = record?.job?.location?.timezone_lookup ?? 'America/Los_Angeles';

  return <DateTimeField {...props} source={source} timeZone={timezone} />;
};

export default JobProfileAvailabilityField;
